<template>
  <section class="schedule">
    <div class='container' v-if="Object.keys(timetable).length">
      <div class="schedule__wrapper" style="overflow: hidden; padding: 0 10px">
        <h1 class="schedule__title" v-if="!hidetitle">Расписание</h1>
        <div class="schedule__slider">
          <div class="swiper-container" data-mobile="false">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
              <!-- Slides -->
              <div class="swiper-slide" v-for="i in Math.round(Object.keys(timetable).length/6)?Math.round(Object.keys(timetable).length/6):1" :key="i">
                <div class="schedule__item item-schedule">
                  <div class="item-schedule__block">
                    <div class="item-schedule-line" v-for="(array, date) in timetable" v-if="Object.keys(timetable).indexOf(date) < (i*6 - 3) && Object.keys(timetable).indexOf(date) >= ((i-1)*6)" :key="date">
                      <p class="item-schedule__date">{{array.day}}</p>
                      <div class="item-schedule__info" v-for="(value, id) in array.rows" :key="id">
                        <!--router-link tag="span" v-if="value.cf[221]" :to="'/' + value.cf[221]" class="item-schedule__img">
                          <picture><source srcset="/static/assets/img/schedule/watch.svg" type="image/webp"><img src="/static/assets/img/schedule/watch.svg" alt="" /></picture>
                        </router-link-->
                        <router-link tag="span" v-if="value.cf[412]" :to="'/' + value.cf[412]" class="item-schedule__img">
                          <picture><source srcset="/static/assets/img/schedule/watch.svg" type="image/webp"><img src="/static/assets/img/schedule/watch.svg" alt="" /></picture>
                        </router-link>
                        <div class="item-schedule__time">{{value.time}}</div>
                        <h3 class="item-schedule__text">{{value.name}}</h3>
                        <div class="item-schedule__btn-wrapper">
                          <button class="item-schedule__btn" data-popup="popup-order" v-if="value.cf[153] !== 'Мест нет' && value.cf[153]" @click="showModal(33, value.name, value.date + ' ' + value.time, (value.cf[155].toLowerCase().indexOf('бесплатно'))?350:0)">Записаться</button>
                          <button class="item-schedule__btn" data-popup="popup-order" v-else-if="value.cf[409] !== 'Мест нет' && value.cf[409]" @click="showModal(3, value.name, value.date + ' ' + value.time, (value.cf[411].toLowerCase().indexOf('бесплатно'))?350:0)">Записаться</button>
                          <button class="item-schedule__btn" v-else>Мест нет</button>
                          <div class="item-schedule__subtext" v-if="value.cf[411] === '' || value.cf[411] === undefined && value.cf[155] === undefined">Мест нет, смотрите на другую дату</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[155] === '' || value.cf[411] === undefined && value.cf[155] === undefined">Мест нет, смотрите на другую дату</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[411]">{{value.cf[411]}} мест</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[155]">{{value.cf[155]}} мест</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-schedule__block">
                    <div class="item-schedule-line" v-for="(array, date) in timetable" v-if="Object.keys(timetable).indexOf(date) >= (i*6 - 3) && Object.keys(timetable).indexOf(date) < (6*i)" :key="date">
                      <p class="item-schedule__date">{{array.day}}</p>
                      <div class="item-schedule__info" v-for="(value, id) in array.rows" :key="id">
                        <!--router-link tag="span" v-if="value.cf[221]" :to="'/' + value.cf[221]" class="item-schedule__img">
                          <picture><source srcset="/static/assets/img/schedule/watch.svg" type="image/webp"><img src="/static/assets/img/schedule/watch.svg" alt="" /></picture>
                        </router-link-->
                        <router-link tag="span" v-if="value.cf[412]" :to="'/' + value.cf[412]" class="item-schedule__img">
                          <picture><source srcset="/static/assets/img/schedule/watch.svg" type="image/webp"><img src="/static/assets/img/schedule/watch.svg" alt="" /></picture>
                        </router-link>
                        <div class="item-schedule__time">{{value.time}}</div>
                        <h3 class="item-schedule__text">{{value.name}}</h3>
                        <div class="item-schedule__btn-wrapper">
                          <button class="item-schedule__btn" data-popup="popup-order" v-if="value.cf[153] !== 'Мест нет'" @click="showModal(33, value.name, value.date + ' ' + value.time, (value.cf[155]?value.cf[155].toLowerCase().indexOf('бесплатно'):value.cf[411].toLowerCase().indexOf('бесплатно'))?350:0)">Записаться</button>
                          <button class="item-schedule__btn" data-popup="popup-order" v-else-if="value.cf[409] !== 'Мест нет'" @click="showModal(3, value.name, value.date + ' ' + value.time, (value.cf[411].toLowerCase().indexOf('бесплатно'))?350:0)">Записаться</button>
                          <button class="item-schedule__btn" v-else>Мест нет</button>
                          <div class="item-schedule__subtext" v-if="value.cf[411] === '' || value.cf[411] === undefined && value.cf[155] === undefined">Мест нет, смотрите на другую дату</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[155] === '' || value.cf[411] === undefined && value.cf[155] === undefined">Мест нет, смотрите на другую дату</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[411]">{{value.cf[411]}} мест</div>
                          <div class="item-schedule__subtext" v-else-if="value.cf[155]">{{value.cf[155]}} мест</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-iptions schedule-swiper-iptions">
                <div class="schedule-button-prev"></div>
                <div v-if="Object.keys(timetable).length > 7" class="swiper-pagination"></div>
                <div class="schedule-button-next"></div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
export default {
  name: 'shedule',
  props: ['timetable', 'hidetitle'],
  watch: {
    timetable: {
      handler () {
        if (Object.keys(this.timetable).length > 7) {
          console.log(Object.keys(this.timetable).length)
          setTimeout(() => { this.initSlider() }, 2000)
        } else console.log(Object.keys(this.timetable).length)
      },
      deep: true
    }
  },
  mounted () {
  },
  methods: {
    initSlider () {
      var slider = document.querySelector('.swiper-container')
      if (slider === null) {
        return
      }
      let swiper

      function desctopSlider () {
        if (window.innerWidth >= 320 && slider.dataset.mobile === 'false') {
          // eslint-disable-next-line
          swiper = new Swiper(slider, {
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>'
              }
            },
            autoHeight: true,
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 800,
            loop: false,
            navigation: {
              nextEl: '.schedule-button-next',
              prevEl: '.schedule-button-prev'
            }

          })
          slider.dataset.mobile = 'true'
        }
        if (window.innerWidth < 320) {
          slider.dataset.mobile = 'false'
          swiper.destroy()
        }
      }
      desctopSlider()

      window.addEventListener('resize', () => {
        desctopSlider()
      })
    },
    moment (date) {
      moment.lang('ru')
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('LL')
    },
    showModal (id, text, time, price) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
      this.$root.requestModalTime = time
      this.$root.requestModalPrice = price
    }
  }
}
</script>

<style scoped>
  .schedule-see-all {
    color: white;
  }
  .swiper-container {
    height: auto;
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/include/shedule.vue